module.exports = __webpack_public_path__ + "static/img/btn_Synthesis_2.b3d8d1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/btn_Synthesis_2.png
// module id = +/9M
// module chunks = 0